export const SESSION_STORAGE_OVERRIDE_TOKEN = 'confidence-override-token';
export const LOCAL_STORAGE_OVERRIDE_TOKEN_PERSIST = `${SESSION_STORAGE_OVERRIDE_TOKEN}-persist`;
